import { globals } from 'common-ui';
import Image from 'next/image';
import { useEffect, useMemo, useState } from 'react';

interface DefaultImageProps {
  imageURL: string;
  isCase: boolean | undefined;
  largeProductMultiView?: boolean;
  altText?: string;
}

const DefaultImage = ({ imageURL, isCase, largeProductMultiView, altText }: DefaultImageProps): JSX.Element => {
  const PRODUCT_IMAGE = 'Product Image';
  const PRODUCT_CASE_DEFAULT_IMAGE = 'product-case-default-image';
  const PRODUCT_BOTTLE_IMAGE = 'product-bottle-image';
  const fallbackSrc = useMemo(
    () => `${globals.publicHost}${globals.defaultImagePath}/${isCase ? 'default_case' : 'default_bottle'}.png`,
    [isCase],
  );

  const [src, setSrc] = useState(imageURL);

  useEffect(() => {
    setSrc(imageURL);
  }, [imageURL]);

  const handleImageError = () => {
    if (src !== fallbackSrc) {
      setSrc(fallbackSrc);
    }
  };

  return (
    <div className="product-image">
      <Image
        src={src}
        alt={altText || PRODUCT_IMAGE}
        className={`${isCase ? PRODUCT_CASE_DEFAULT_IMAGE : PRODUCT_BOTTLE_IMAGE}${src?.includes('default_') ? ' product-image-error' : ''}`}
        width={`${largeProductMultiView ? '1800' : '600'}`}
        height={`${largeProductMultiView ? '1200' : '400'}`}
        onError={handleImageError}
        objectFit="cover"
      />
    </div>
  );
};

export default DefaultImage;
